import React, { useContext } from 'react';
import { CalculatorContext } from '../contexts/CalculatorContext';
import DetachableCalculator from './DetachableCalculator';

const PersistentCalculator = () => {
  const { isCalculatorDetached, handleCalculatorClose } = useContext(CalculatorContext);
  
  if (!isCalculatorDetached) {
    return null;
  }
  
  return <DetachableCalculator onClose={handleCalculatorClose} />;
};

export default PersistentCalculator; 